module.exports = __webpack_public_path__ + "img/40_69_014_160.586ff8e1.jpg";